export default {
    isLoading: state => state.isLoading,
    isAlert: state => state.isAlert,
    isAlertText: state => state.isAlertText,
};
